module.exports = __webpack_public_path__ + "img/KH.9fd34914.svg";